import ApiService from "../ApiService";

const ForceShippingFeeService = {
  async forceShippingFeeAll() {
    return ApiService.get(
      'force-shipping-fee/all'
    )
  }
}

export default ForceShippingFeeService
